module.exports = __webpack_public_path__ + "static/media/Ecologica.03903c3d.jpg";